import styled from 'styled-components'

import { helpers } from 'styles'

import { HeaderRow as DefaultHeaderRow } from 'components/Lists'

export const HeaderRow = styled(DefaultHeaderRow)`
	font-size: 16px;
	padding: ${helpers.spacing.large} ${helpers.spacing.large};
	column-gap: 9px;
`
